import Diverged from './Diverged'

export default Diverged
